import { useIntl } from 'react-intl'
import { getApiError } from '@/api/helpers/apiError'
import { extractErrorMessage } from '@/api/helpers/extractErrorMessage'
import { useInvalidateDeploymentList } from '@/queries/deploymentQueries'
import { showToast } from '@/theme/notifications'

type RunMessages = {
  inProgress: string
  error: string
}

const isGroupNotDispatchable = (err: unknown) => {
  const { status, data } = getApiError(err)

  return status === 409 && data?.errors?.[0]?.code === 'group_not_dispatchable'
}

export const useRunDeploymentAction = (onDone: () => void) => {
  const intl = useIntl()
  const { invalidateDeploymentList } = useInvalidateDeploymentList()

  return async (action: () => Promise<unknown>, messages: RunMessages) => {
    try {
      await action()

      showToast(intl.formatMessage({ id: messages.inProgress }), 'info')

      void invalidateDeploymentList()
      onDone()
    } catch (err) {
      showToast(
        isGroupNotDispatchable(err)
          ? intl.formatMessage({ id: 'deployments.groups.actions.notReady' })
          : extractErrorMessage(
              err,
              intl.formatMessage({ id: messages.error })
            ),
        'error'
      )
    }
  }
}
